<svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
<g>
  <path d="M10.2619 4.56061C10.4942 3.81313 11.5058 3.81313 11.7381 4.56061L13.0328 8.72631H17.2224C17.9742 8.72631 18.2868 9.73205 17.6786 10.194L14.2891 12.7685L15.5838 16.9342C15.8161 17.6817 14.9977 18.3034 14.3895 17.8414L11 15.2668L7.61047 17.8414C7.00226 18.3034 6.18392 17.6817 6.41623 16.9342L7.71092 12.7685L4.32139 10.194C3.71318 9.73205 4.02576 8.72631 4.77755 8.72631H8.96724L10.2619 4.56061Z" fill="currentColor"/>
</g>
</svg>
